import {
  faBookmark,
  faCalendarXmark,
  faClipboardList,
  faFileContract,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import createField from "../../../utils/factory/createField";

export const filterFields = [
  {
    section: "Filtros para o relatório",
    fields: [
      createField({
        id: "filter.mode",
        label: "Modo do relatório",
        placeholder: "Selecione o modo do relatório",
        type: "select",
        icon: faClipboardList,
        fullWidth: true,
      }),
      createField({
        id: "filter.customer_id",
        label: "Cliente Contratante",
        placeholder: "Selecione o cliente contratante",
        type: "select",
        icon: faUser,
        isClearable: true,
      }),
      createField({
        id: "filter.contract_id",
        label: "Contrato",
        placeholder: "Selecione o contrato (opcional)",
        type: "select",
        icon: faFileContract,
        isClearable: true,
      }),
      createField({
        id: "filter.only_expired",
        label: "Somente vencidos?",
        placeholder: "Selecione Sim ou Não",
        type: "select",
        icon: faCalendarXmark,
      }),
      createField({
        id: "filter.with_excess",
        label: "Somente com excedentes?",
        placeholder: "Selecione Sim ou Não",
        type: "select",
        icon: faBookmark,
      }),
    ],
  },
];
